import React from "react";
import GaugeChart from "react-gauge-chart";

const AngularVelocity = () => {
  let obtainedValue = -4.4;
  let percentageValue = (obtainedValue + 10) * 5;
  let cener = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  };
  return (
    <div style={cener}>
      <GaugeChart
        percent={percentageValue * 0.01}
        id="angularVeloChart"
        nrOfLevels={20}
        colors={["#ffedf1", "#ff8fa6"]}
        needleColor="#FFE3E9"
        needleBaseColor="#f8b6c3"
        textColor="#FF8FA6"
        formatTextValue={(val) => val / 5 - 10}
      />

      <span>Angular Velocity</span>
    </div>
  );
};

export default AngularVelocity;
